const ProductDescription = () => {
    return (
        <>
            Generate stunning PowerPoint slides, reply to messages in Outlook &
            Teams, craft elegant documents in Microsoft Word - all with the
            help&nbsp;of&nbsp;AI.
        </>
    );
};

export default ProductDescription;
